'use client';
import styles from './pagination.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faChevronLeft,
	faChevronRight,
	faChevronsLeft,
	faChevronsRight,
} from '@awesome.me/kit-012d1b9af0/icons/classic/regular';
import { useProperties } from '@/context/properties-context';
import { useTrials } from '@/context/trials-context';
import { useScrollToTop } from '@/hooks/use-scroll';

export default function Pagination() {
	useScrollToTop();

	const {
		properties: { page, trialsPerPage },
		updateProperty,
	} = useProperties();

	const { trialsCount, isLoading } = useTrials();

	const lastPage = Math.ceil(trialsCount / trialsPerPage);

	function onFirst() {
		if (isLoading) return;
		if (page > 1) updateProperty('page', 1);
	}

	function onPrevious() {
		if (isLoading) return;
		if (page > 1) updateProperty('page', page - 1);
	}

	function onNext() {
		if (isLoading) return;
		if (page < lastPage) updateProperty('page', page + 1);
	}

	function onLast() {
		if (isLoading) return;
		if (page < lastPage) updateProperty('page', lastPage);
	}

	const start = (page - 1) * trialsPerPage + 1;
	const end = Math.min(page * trialsPerPage, trialsCount);

	if (isLoading || trialsCount === 0) return null;

	return (
		<div className={styles.pagination}>
			<div className={styles['pagination-text']}>
				<p>
					Showing {start} - {end} of {trialsCount} Trials{' '}
				</p>
			</div>

			<div className={styles['pagination-btns']}>
				<FontAwesomeIcon
					icon={faChevronsLeft}
					onClick={onFirst}
					color={page === 1 ? '#555555' : '#446cb3'}
					style={{ cursor: page === 1 ? 'not-allowed' : 'pointer' }}
				/>
				<FontAwesomeIcon
					icon={faChevronLeft}
					className={styles.icon}
					onClick={onPrevious}
					color={page === 1 ? '#555555' : '#446cb3'}
					style={{ cursor: page === 1 ? 'not-allowed' : 'pointer' }}
				/>
				<p className={styles['pagination-text']}>Previous - Next</p>
				<FontAwesomeIcon
					icon={faChevronRight}
					className={styles.icon}
					onClick={onNext}
					color={page === lastPage ? '#555555' : '#446cb3'}
					style={{ cursor: page === lastPage ? 'not-allowed' : 'pointer' }}
				/>
				<FontAwesomeIcon
					icon={faChevronsRight}
					className={styles.icon}
					onClick={onLast}
					color={page === lastPage ? '#555555' : '#446cb3'}
					style={{ cursor: page === lastPage ? 'not-allowed' : 'pointer' }}
				/>
			</div>
		</div>
	);
}
